import { useState, useCallback } from 'react';
import { Flex, Box, Button, Message } from 'components/ui';
import { ArrowUp, ArrowDown } from 'components/ui/Arrows';
import { futuraChainId, futuraContractAddress } from 'utils/config';
import ApproveToken from 'components/ApproveToken';
import { Contract } from '@ethersproject/contracts';
import { notifyTx } from 'utils/notifications';

interface FuturaRedeemProps {
  mixPassBalance: number;
  mixpassContract: Contract;
  mintMixes: (count:number, cb?:any) => any;
  onSuccess: () => void;
  userAddress: string;
}

const FuturaRedeem = ({
  mixPassBalance,
  mixpassContract,
  mintMixes,
  onSuccess,
  userAddress,
}: FuturaRedeemProps) => {
  const [count, setCount] = useState<number>(1);
  const [pending, setPending] = useState<boolean>(false);

  function incrementCount() {
    const max = Math.min(10, mixPassBalance);
    if (count === max) return;
    setCount(last => last + 1);
  }

  function decrementCount() {
    if (count <= 1) return;
    setCount(last => last - 1);
  }
  
  const mint = useCallback(async () => {
    notifyTx({
      method: () => mintMixes(count),
      chainId: futuraChainId,
      success: `Your Mixpass was redeemed! You'll find your Futura Mixes in your collection shortly.`,
      onSuccess: () => {
        onSuccess();
        setPending(false)
      },
      onSubmitted: () => setPending(true),
      onError: () => setPending(false),
      error: 'An error occured while trying to redeem your mixpass',
    });
  }, [count, mintMixes, onSuccess]);

  return (
    <>
      <Box mt={2} mb={4}>
        <ul>
          <li>Each Mixpass can be redeemed for two Futura Mix NFTs.</li>
          <li>Up to 10 Mixpass NFTs can be redeemed per transaction.</li>
          <li>At the end of the redemption period, all Futura Mix NFTs will be fully revealed.</li>
          <li><b>Please be aware - Redemption is for a limited time only and scheduled to end on December 6th. Mixpass NFTs will no longer able to be redeemed after the redemption period ends.</b></li>
          <li>If you own multiple Mixpasses, we advise you keeping one Mixpass unredeemed. Unredeemed Mixpass NFTs permit holders to a 25% discount on Remixing. However this discount does not stack if you retain more than one.</li>
        </ul>
      </Box>
      {
        mixPassBalance > 0 ? (
          <Box>
            <Message mb={4} color="black">
              You have { mixPassBalance } Mixpass{ mixPassBalance !== 1 && 'es'} left to redeem.
            </Message>
            <ApproveToken
              spendingContractAddress={futuraContractAddress}
              tokenContract={mixpassContract}
              userAddress={userAddress}
              approveLabel="Approve Mixpass"
            >
              <Flex>
                <Flex alignCenter>
                  <Box
                    border={`3px solid #7530ce`}
                    py="2"
                    px="3"
                    fontSize="4"
                    borderRadius="2"
                  >
                    { count }
                  </Box>
                  <Flex column alignCenter height="100%" ml="1" mr="3">
                    <ArrowUp
                      color="#7530ce"
                      size={10}
                      mb="1"
                      onClick={incrementCount}
                      disabled={mixPassBalance === 0}
                    />
                    <ArrowDown color="#7530ce" size={10} onClick={decrementCount} disabled={mixPassBalance === 0} />
                  </Flex>
                </Flex>
                <Button
                  onClick={mint}
                  background="#7530ce"
                  disabled={mixPassBalance === 0 || pending}
                  color="white"
                >
                  Redeem
                </Button>
              </Flex>
            </ApproveToken>
          </Box>
        ) : (
          <Message mb={4} color="black">
            You don't have any Mixpasses in this wallet.
          </Message>
        )
      }
    </>
  )
}

export default FuturaRedeem;
